<template>
  <div class="wrapHeight">
    <div
      v-if="showSelectAll"
      class="flex items-center mb-2 pl-2"
    >
      <el-checkbox
        v-model="isSelectAll"
        @change="handleSelectAll"
      >全选</el-checkbox>
    </div>
    <!-- <ad-form
      :filedList="filedList"
      v-model="formData"
      :formPrams="formPrams"
      @change="change"
    >
    </ad-form> -->
    <div
      v-if="materialList?.length > 0"
      class="flex flex-wrap"
    >
      <MaterialList :mainMenuList="materialList">
        <template v-slot:default="scope">
          <!-- {{ scope }} -->
          <div
            class="imgWrap relative box-border p-2 cursor-pointer shadow-md rounded-lg"
            @click.stop="(event) => choose(event, scope.img.id, scope.img)"
          >
            <img
              v-if="scope.img.type == 'IMAGE'"
              :src="scope.img.url"
              class="w-full h-full"
              fit="contain"
            />
            <span
              class="absolute right-3 top-3"
              :class="[chooseList.indexOf(scope.img.id) >= 0 ? 'activeCheck' : '']"
              ><i class="el-icon-success"></i
            ></span>
            <el-tooltip
              effect="dark"
              :content="scope.img.name"
              placement="top"
            >
              <p class="text-gray-600 font-bold text-sm mt-1 text-wrap line-clamp-2 overflow-ellipsis w-full">
                {{ scope.img.name }}
              </p>
            </el-tooltip>

            <div class="flex items-center justify-between text-gray-400 text-xs mt-1">
              <p>{{ scope.img.width }}*{{ scope.img.height }}</p>
              <p>{{ (scope.img.fileSize / 1024 / 1024).toFixed(2) }}MB</p>
            </div>
          </div>
        </template>
      </MaterialList>
    </div>
    <el-empty
      v-else
      description="暂无数据"
    >
      <el-button
        icon="el-icon-refresh-right"
        circle
        @click="getList"
      ></el-button>
    </el-empty>
  </div>
</template>
<script>
import { MaterialList } from '@adCommonComponent';
import { assetList } from '@/api/google/create';
import { toFixed } from '@/utils/directive';
export default {
  components: {
    MaterialList,
  },
  props: {
    accountId: {
      type: String | Number,
      default: () => '',
    },
    chooseList: {
      type: Array,
      default: () => [],
    },
    showSelectAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      materialList: [],
      isSelectAll: false,
    };
  },
  methods: {
    updateSelectAllStatus() {
      if (!this.showSelectAll || this.materialList.length === 0) {
        this.isSelectAll = false;
        return;
      }
      this.isSelectAll = this.materialList.every((item) => this.chooseList.includes(item.id));
    },
    handleSelectAll(val) {
      if (val) {
        this.materialList.forEach((item) => {
          if (!this.chooseList.includes(item.id)) {
            this.$emit('choose', item.id, item);
          }
        });
      } else {
        this.materialList.forEach((item) => {
          if (this.chooseList.includes(item.id)) {
            this.$emit('choose', item.id, item);
          }
        });
      }
    },
    // 获取列表
    async getList() {
      this.$showLoading();
      await assetList({ accountId: this.accountId })
        .then((res) => {
          if (res.code == 0) {
            this.materialList = res.data;
          } else {
            this.materialList = [];
          }
        })
        .finally(() => {
          this.$hideLoading();
        });
    },
    choose(event, id, item) {
      this.$emit('choose', id, item);
    },
  },
  watch: {
    chooseList: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
    materialList: {
      handler() {
        this.updateSelectAllStatus();
      },
      deep: true,
    },
  },
  async created() {
    await this.getList();
  },
};
</script>
<style scoped lang="scss">
.wrapHeight {
  height: calc(100vh - 158px);
  overflow-y: scroll;
}
.imgWrap {
  background-color: #f5f5f5;

  &:hover {
    span {
      i {
        opacity: 0.6;
      }
    }
  }

  video {
    min-height: 233px;
  }

  span {
    position: absolute;
    right: 12px;
    top: 12px;
    &.activeCheck {
      i {
        color: #409eff;
        opacity: 1;
      }
    }

    i {
      font-size: 24px;
      color: #999;
      opacity: 0;
    }
  }
}
</style>
